import * as Yup from "yup";

const postalcodeRegex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/;
const noEmojiRegex = /\p{Extended_Pictographic}/u;

const baseSchemaShape = {
  firstName: Yup.string()
    .trim()
    .max(50, "Less than 50 characters, please.")
    .required("You missed this one"),
  lastName: Yup.string()
    .trim()
    .max(50, "Less than 50 characters, please.")
    .required("You missed this one"),
  dateOfBirth: Yup.string()
    .matches(dateRegex, "Please enter your birth date in the MM/DD/YYYY format")
    .required("You missed this one")
    .test(
      "future date",
      "Hello time traveler! Please pick date in the past",
      (value) => new Date(value || "") <= new Date()
    ),
  gender: Yup.string().required("You missed this one"),
  homeZip: Yup.string()
    .matches(
      postalcodeRegex,
      "Zip code should be 5 digits or 5+4 digits. For example, 10041 or 10041-0004."
    )
    .required("You missed this one"),
};

export const cobraValidationSchema = Yup.object().shape(baseSchemaShape);

export const employeeCensusValidationSchema = Yup.object().shape({
  firstName: baseSchemaShape.firstName,
  lastName: baseSchemaShape.lastName,
  employeeType: Yup.string().required("You missed this one"),
  isWaiving: Yup.string().required("You missed this one"),
  dateOfBirth: baseSchemaShape.dateOfBirth,
  gender: baseSchemaShape.gender,
  homeZip: baseSchemaShape.homeZip,
  state: Yup.string()
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
});

export const dependentCensusValidationSchema = Yup.object().shape({
  firstName: baseSchemaShape.firstName,
  lastName: baseSchemaShape.lastName,
  participantType: Yup.string().required("You missed this one"),
  dateOfBirth: baseSchemaShape.dateOfBirth,
  gender: baseSchemaShape.gender,
  homeZip: baseSchemaShape.homeZip,
  state: Yup.string()
    .required("You missed this one")
    .test(
      "no emoji",
      "Sorry, no emoji 😔",
      (value) => !noEmojiRegex.test(value || "")
    ),
});

export const cobraDependentValidationSchema = Yup.object().shape({
  firstName: baseSchemaShape.firstName,
  lastName: baseSchemaShape.lastName,
  participantType: Yup.string().required("You missed this one"),
  dateOfBirth: baseSchemaShape.dateOfBirth,
  gender: baseSchemaShape.gender,
  homeZip: baseSchemaShape.homeZip,
});
